import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ENV } from '../core-ng/injection-token';
import {
  ISurveyPlugin,
  SurveyPluginUsage,
} from '@hyper-inferno/survey-elements-core';

@Injectable({
  providedIn: 'root',
})
export class SurveyPluginService {
  private http = inject(HttpClient);
  environment = inject(ENV);

  getSurveyPlugins(): Observable<ISurveyPlugin[]> {
    return this.http.get<ISurveyPlugin[]>(
      `${this.environment.consoleApi}/survey-plugin/get-plugins`,
    );
  }

  getSurveyPluginUsages(survey_id: number): Observable<SurveyPluginUsage[]> {
    return this.http.get<SurveyPluginUsage[]>(
      `${this.environment.consoleApi}/survey-plugin/get-plugin-usages/${survey_id}`,
    );
  }

  createPluginUsage(payload: SurveyPluginUsage): Observable<SurveyPluginUsage> {
    return this.http.post<any>(
      `${this.environment.consoleApi}/survey-plugin/create-plugin-usage`,
      payload,
    );
  }

  updatePluginUsage(payload: {
    id: string;
    element_id?: number | null;
    page_id?: number | null;
  }) {
    return this.http.post(
      `${this.environment.consoleApi}/survey-plugin/update-plugin-usage`,
      payload,
    );
  }

  removePluginUsage(id: string) {
    return this.http.post(
      `${this.environment.consoleApi}/survey-plugin/remove-plugin-usage`,
      { id },
    );
  }
}
